module.exports = __webpack_public_path__ + "media/svg/jo-6d45f2e5.svg";